export const isIE = () => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    return (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1)
}
